var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "return-policy" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("footer-com", {
        key: _vm.showan,
        attrs: { value: _vm.showan },
        on: {
          hideShow: function($event) {
            _vm.showan = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { attrs: { dir: "ltr" } }, [
      _c(
        "h1",
        {
          staticStyle: {
            "margin-right": "0",
            "margin-left": "0",
            "font-family": "Graphik",
            "white-space": "normal",
            "text-align": "center",
            background: "white"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                "font-family": "Graphik",
                color: "rgb(51, 51, 51)"
              }
            },
            [_vm._v("SHOPVIDI INC. PRODUCT GUIDELINES")]
          )
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _c("span", { staticClass: "bolder_style" }),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _vm._v(" "),
      _c("p", { attrs: { id: "info_tittle", "data-post-processed": "true" } }, [
        _c("b", [_vm._v("1. Product Compliance")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "It is your responsibility to ensure that all products and related content that you make available on the ShopVidi marketplace meet these requirements set forth in these Product Guidelines. ShopVidi Inc. (“"
        ),
        _c("span", { staticClass: "bolder_style" }, [_vm._v("ShopVidi")]),
        _vm._v(
          "”) reserves the right to update these Product Guidelines from time to time, so please check back periodically for changes. Throughout these Product Guidelines, the word “include” or “including” means “including, but not limited to”. Capitalized terms used herein but not defined shall have the meanings given to them in the general Terms of Service, Brand Terms of Service, Retailer Terms of Service and/or other terms and policies, as applicable, and the terms and conditions of all of the foregoing are incorporated herein by reference. You acknowledge and agree to:"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "1.abide by these Product Guidelines, Terms of Service, Brand Terms of Service, Retailer Terms of Service, and/or any other special terms and policies, as applicable;"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "2.comply with all applicable laws, rules and regulations, including safety, labeling, testing, warning, import, export, regional certifications and all other applicable consumer protection law requirements;"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "3.not infringe upon the intellectual property, publicity or other rights of any third parties;"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "4.not provide any false, inaccurate or misleading information about your products; and"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "5.ensure that the products you sell are allowed to be sold from your jurisdiction and into a Retailer’s jurisdiction."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "You acknowledge and agree that ShopVidi is not responsible for determining whether you meet the above requirements, and you hereby release ShopVidi from any liability with respect thereto. Your compliance with the foregoing requirement is a material condition of your participation as a Seller on the ShopVidi marketplace."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _vm._v(" "),
      _c("p", { attrs: { id: "info_tittle", "data-post-processed": "true" } }, [
        _c("b", [_vm._v("2. Prohibited Products")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "ShopVidi does not allow any of the following products on the ShopVidi marketplace:"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Counterfeit products or products that you do not have the right to sell (e.g., products that you do not make or that are not under your brand)"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Firearms / firearm ammunition")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Weapons, including knives, explosives and related items")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Products containing any amount of alcohol")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Products containing any amount of drugs, including prescription, legal or illegal drugs"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Any products that contain Cannabidiol (CBD) or Tetrahydrocannabinol (THC)"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Drug paraphernalia")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Cigarettes, cigars, tobacco, electronic cigarettes, vape sticks or pens, hookah pipes and other smoking paraphernalia"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Any hazardous, toxic, flammable, biohazardous, unsafe or dangerous products"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Any recalled products")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Dietary supplements")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Animal or animal products, including fur (excluding leather goods)"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Children’s car seats or harnesses")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Pornography, including images, videos or other offensive materials"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Products that are offensive or promote, incite or glorify hate or violence towards any person or group"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Culturally insensitive products")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Products related to terrorist organizations")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Confederate flag merchandise")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Digital goods, including software")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Gift cards")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Currency, coins, cash equivalents, Bitcoin or other similar digital currency"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Stamps")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Fine art")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Gambling or lottery related items")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Any perishable foods, including meat, fish, vegetables, fruits and dairy products"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Any products containing asbestos or flame-retardant chemicals")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Counterfeit goods")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v("Used goods")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height margin_border" }, [
        _vm._v(
          "Any other products that ShopVidi determines in its discretion to be inappropriate for availability on the ShopVidi marketplace."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _vm._v(" "),
      _c("p", { attrs: { id: "info_tittle", "data-post-processed": "true" } }, [
        _c("b", [_vm._v("3. Compliance with Laws")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "Brands are responsible for being familiar with and complying with all applicable laws, rules and regulations relevant to the products they make available through ShopVidi (whether international, federal, state, local or otherwise). This includes the following (but please note this list is not exhaustive and some may not be applicable to you. It is your responsibility to know what laws, rules and regulations apply to you):"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("1.Packaging and product labeling laws (apparel or otherwise)")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("2.“Made in America” laws")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("3.Eco-friendly laws")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("4.Plastic bag warning labels and laws")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "5.California’s Prop 65 (the Safe Drinking Water and Toxic Enforcement Act of 1986)"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("6.California’s Compliance with Metal Containing Jewelry law")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v("7.Product liability laws")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _vm._v(" "),
      _c("p", { attrs: { id: "info_tittle", "data-post-processed": "true" } }, [
        _c("b", [_vm._v("4. Recalled Products")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "Brands agree to immediately inform ShopVidi if any products have been recalled, giving the following information: (a) product name; (b) SKU number or other identifying number; (c) number of units sold to Retailers; (d) purpose of recall; and (e) any other information necessary so that the products may be properly and quickly recalled."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }),
      _vm._v(" "),
      _c("p", { attrs: { id: "info_tittle", "data-post-processed": "true" } }, [
        _c("b", [_vm._v("5. Violation of These Product Guidelines")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin text_line_height" }, [
        _vm._v(
          "If you breach any of these Product Guidelines, ShopVidi will have the right to deactivate products, temporarily suspend or permanently terminate your account and/or ShopVidi’s general Terms of Service and/or Brand Terms of Service, in its sole discretion and without prior notice to you."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c5e8236", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c5e8236","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3Policy.vue
// module id = null
// module chunks = 